import { render, staticRenderFns } from "./GreatValue.vue?vue&type=template&id=3416d1fe&scoped=true&"
import script from "./GreatValue.vue?vue&type=script&lang=js&"
export * from "./GreatValue.vue?vue&type=script&lang=js&"
import style0 from "./GreatValue.vue?vue&type=style&index=0&id=3416d1fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3416d1fe",
  null
  
)

export default component.exports